<template>
    <div class="block">
    <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getItems">Сотрудничество с вузами-участниками проекта</a>
    <transition name="fade">
        <div class="content" v-if="isLoad">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>Наименование вуза-участника проекта</th>
                    <th>Номер соглашения</th>
                    <th>Копия договора</th>
                    <th>Количество выпускников, поступивших в указанный вуз</th>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:key="item.id" v-for="item in filterByProject">
                    <td>{{item.institute.name}}</td>
                    <td>{{item.contract}}</td>
                    <td>
                        <a v-if="item.copyContract" :href="item.copyContract" target="_blank">Файл</a>
                    </td>
                    <td>{{item.numberStudents}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </transition>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    export default {
        name: "CooperationMember",
        data(){
            return {
                isLoad:false,
            }
        },
        computed: {
            ...mapState('CooperationMember', {
               items : state => state.items
            }),
            ...mapGetters('CooperationMember', ['filterByProject'])
        },
        methods:{
            getItems(){
                const $this = this
                if(!this.isLoad) {
                    if(!this.items) {
                        this.$store.dispatch('CooperationMember/getItems').then(() => {
                            $this.isLoad = true
                        })
                    }else{
                        this.isLoad = true
                    }
                }else{
                    this.isLoad = false
                }
            }
        }
    }
</script>

<style scoped>

</style>
